import { Dispatch } from 'redux';
import { Reminder } from '../../models';
import Reminders from '../../services/Reminders';
import { createRestSlices, applyReducers } from './rest';
import { ActionPayload } from '..';
import type { Callback } from './rest';
import { removeFromList, upsertList } from './remoteUpdate';

const {
    initialState, resetReducer,
    createReducer, startCreateReducer,
    getReducer, listReducer,
    updateReducer, deleteReducer,
    resetAction, createAction, startCreateAction,
    getAction, listAction,
    updateAction, deleteAction,
} = createRestSlices(Reminders);

const CHANGE_ROUTINE = 'yoda/reminders/CHANGE_ROUTINE';
const addActionReducer = (state = initialState, action: ActionPayload) => {
    switch (action.type) {
        case CHANGE_ROUTINE:
            return {
                ...state,
                reminder: { ...state.reminder }
            };
        default:
            return state;
    }
};

const UPDATE = 'yoda/mercure/REMOTE_UPDATE';
const onRemoteUpdateReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== UPDATE)
        return state;

    const { update: { data, type }} = action;
    switch (type) {
        case 'reminder.created':
            return {
                ...state,
                reminders: upsertList(state.reminders, data, (payload) => new Reminder(payload), true)
            };
        case 'reminder.updated':
            return {
                ...state,
                reminders: upsertList(state.reminders, data, (payload) => new Reminder(payload)),
                reminder: state.reminder?._id === data._id ? new Reminder(data) : state.reminder
            };
        case 'reminder.deleted':
        case 'reminder.reached':
            return {
                ...state,
                reminders: removeFromList(state.reminders, data._id),
                reminder: state.reminder?._id === data._id ? null : state.reminder
            };
        default:
            return state;
    }
};
/* Export reducer */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action: ActionPayload) => {
    return applyReducers(state, action, [
        resetReducer,
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        addActionReducer, onRemoteUpdateReducer
    ]);
}

const changeReminderAction = (reminder: Reminder, callback?: Callback) => {
    return async (dispatch: Dispatch) => {
        dispatch({ type: CHANGE_ROUTINE, reminder });
        callback && callback(/*err*/null);
    }
}

/* Export CRUD actions */
export const resetReminder       = resetAction;
export const createReminder      = createAction;
export const startCreateReminder = startCreateAction;
export const loadReminder        = getAction;
export const loadReminders       = listAction;
export const updateReminder      = updateAction;
export const deleteReminder      = deleteAction;
export const changeReminder      = changeReminderAction;
